import React from 'react';

export default function IndexSectionLogoCloudsWhitePattern14() {
    return (
        <React.Fragment>
            <>
                <section className="py-10 bg-white" style={{backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")', backgroundPosition: 'center'}}>
  <div className="container px-4 mx-auto">
    <div className="flex flex-wrap items-center -mx-4 mb-16">
      <div className="w-full md:w-1/2 px-4 mb-16 md:mb-0">
        <span className="inline-block py-px px-2 mb-4 text-xl leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl">Global Distribution</span>
        <h2 className="mb-6 text-4xl md:text-5xl leading-tight font-bold tracking-tighter">Exported to clients worldwide</h2>
        <p className="text-lg md:text-xl text-coolGray-500 font-medium">Our manufacturing expertise serves clients across multiple continents, with custom-designed tool storage solutions reaching professionals in these major markets and beyond.</p>
      </div>
      
      <div className="w-full md:w-1/2 px-4">
        <style jsx="true">{`
          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
            100% { transform: translateY(0px); }
          }
          
          .global-flags-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 1.5rem;
            max-width: 100%;
            margin: 0 auto;
          }
          
          @media (min-width: 768px) {
            .global-flags-grid {
              grid-template-columns: repeat(4, 1fr);
            }
          }
          
          .flag-wrapper {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            transition: all 0.3s ease;
          }
          
          .flag-wrapper:hover .flag-image {
            transform: scale(1.08);
            box-shadow: 0 20px 30px rgba(0, 0, 0, 0.15);
          }
          
          .flag-wrapper:hover .country-name {
            opacity: 1;
            transform: translateY(0);
          }
          
          .flag-image {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            object-fit: cover;
            box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            position: relative;
            z-index: 1;
          }
          
          .flag-image.spain { animation: float 6s ease-in-out infinite; }
          .flag-image.france { animation: float 6s ease-in-out infinite 0.75s; }
          .flag-image.uk { animation: float 6s ease-in-out infinite 1.5s; }
          .flag-image.usa { animation: float 6s ease-in-out infinite 2.25s; }
          .flag-image.germany { animation: float 6s ease-in-out infinite 3s; }
          .flag-image.netherlands { animation: float 6s ease-in-out infinite 3.75s; }
          .flag-image.canada { animation: float 6s ease-in-out infinite 4.5s; }
          .flag-image.mexico { animation: float 6s ease-in-out infinite 5.25s; }
          
          .flag-glow {
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            z-index: 0;
            opacity: 0.5;
            filter: blur(20px);
            transform: scale(0.85);
            transition: all 0.3s ease;
          }
          
          .flag-wrapper:hover .flag-glow {
            opacity: 0.7;
            transform: scale(0.9);
          }
          
          .spain-glow { background: radial-gradient(circle, #f1bf00 0%, rgba(241, 191, 0, 0) 70%); }
          .france-glow { background: radial-gradient(circle, #002395 0%, rgba(0, 35, 149, 0) 70%); }
          .uk-glow { background: radial-gradient(circle, #012169 0%, rgba(1, 33, 105, 0) 70%); }
          .usa-glow { background: radial-gradient(circle, #3c3b6e 0%, rgba(60, 59, 110, 0) 70%); }
          .germany-glow { background: radial-gradient(circle, #dd0000 0%, rgba(221, 0, 0, 0) 70%); }
          .netherlands-glow { background: radial-gradient(circle, #21468b 0%, rgba(33, 70, 139, 0) 70%); }
          .canada-glow { background: radial-gradient(circle, #ff0000 0%, rgba(255, 0, 0, 0) 70%); }
          .mexico-glow { background: radial-gradient(circle, #006847 0%, rgba(0, 104, 71, 0) 70%); }
          
          .country-name {
            margin-top: 1rem;
            font-weight: 600;
            font-size: 1rem;
            color: #1a202c;
            opacity: 0.9;
            transition: all 0.3s ease;
            position: relative;
          }
          
          .country-name::after {
            content: '';
            position: absolute;
            bottom: -6px;
            left: 50%;
            width: 0;
            height: 2px;
            background: currentColor;
            transition: all 0.3s ease;
            transform: translateX(-50%);
          }
          
          .flag-wrapper:hover .country-name::after {
            width: 100%;
          }
        `}</style>
        
        <div className="global-flags-grid">
          <div className="flag-wrapper">
            <div className="flag-glow spain-glow"></div>
            <img 
              src="/flags/spain-circle.svg" 
              alt="Spain" 
              className="flag-image spain" 
            />
            <div className="country-name">Spain 🇪🇸</div>
          </div>
          
          <div className="flag-wrapper">
            <div className="flag-glow france-glow"></div>
            <img 
              src="/flags/france-circle.svg" 
              alt="France" 
              className="flag-image france" 
            />
            <div className="country-name">France 🇫🇷</div>
          </div>
          
          <div className="flag-wrapper">
            <div className="flag-glow uk-glow"></div>
            <img 
              src="/flags/uk-circle.svg" 
              alt="United Kingdom" 
              className="flag-image uk" 
            />
            <div className="country-name">UK 🇬🇧</div>
          </div>
          
          <div className="flag-wrapper">
            <div className="flag-glow usa-glow"></div>
            <img 
              src="/flags/usa-circle.svg" 
              alt="United States" 
              className="flag-image usa" 
            />
            <div className="country-name">USA 🇺🇸</div>
          </div>
          
          <div className="flag-wrapper">
            <div className="flag-glow germany-glow"></div>
            <img 
              src="/flags/germany-circle.svg" 
              alt="Germany" 
              className="flag-image germany" 
            />
            <div className="country-name">Germany 🇩🇪</div>
          </div>
          
          <div className="flag-wrapper">
            <div className="flag-glow netherlands-glow"></div>
            <img 
              src="/flags/holland-circle.svg" 
              alt="Netherlands" 
              className="flag-image netherlands" 
            />
            <div className="country-name">Netherlands 🇳🇱</div>
          </div>
          
          <div className="flag-wrapper">
            <div className="flag-glow canada-glow"></div>
            <img 
              src="/flags/canada-circle.svg" 
              alt="Canada" 
              className="flag-image canada" 
            />
            <div className="country-name">Canada 🇨🇦</div>
          </div>
          
          <div className="flag-wrapper">
            <div className="flag-glow mexico-glow"></div>
            <img 
              src="/flags/mexico-circle.svg" 
              alt="Mexico" 
              className="flag-image mexico" 
            />
            <div className="country-name">Mexico 🇲🇽</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
            </>
        </React.Fragment>
    );
}
